<template>
    <div class="item-divider">
        <el-button type="text" class="remove-btn f-edit" @click="removeItem(ruleForm)"><span
                class="color-danger">删除</span>
        </el-button>
        <el-form :model="ruleForm" :rules="rules" :class="[{ 'form-view': !isEdit }, 'form-switch', 'form-col']"
                 ref="ruleForm"
                 label-width="100px">
            <div class="col-2 clearfix">
                <el-form-item label="学校名称:" prop="school">
                    <p class="f-view" v-text="ruleForm.school"></p>
                    <el-input class="f-edit" v-model.trim="ruleForm.school" :maxlength="20"
                              placeholder="请输入学校名称"></el-input>
                </el-form-item>
                <el-form-item label="专业名称:" prop="major">
                    <p class="f-view" v-text="ruleForm.major"></p>
                    <el-input class="f-edit" v-model.trim="ruleForm.major" :maxlength="20"
                              placeholder="请输入专业名称"></el-input>
                </el-form-item>
            </div>
            <div class="col-2 clearfix">
                <el-form-item label="学历:" prop="degree">
                    <p class="f-view" v-text="getSelectMapText('WB_EDU_DEGREE', ruleForm.degree)"></p>
                    <el-select class="f-edit" v-model="ruleForm.degree"
                               placeholder="请选择学历">
                        <el-option
                                v-for="(item, index) in selectMap.WB_EDU_DEGREE"
                                :label="item.text"
                                :key="index"
                                :value="parseInt(item.value)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="就读时间:" class="width-longer">
                    <p class="f-view" v-text="durationDateText"></p>
                    <div class="f-edit">
                        <el-date-picker type="month" placeholder="开始时间"
                                        ref="startDate"
                                        v-model="ruleForm.beginDate" @change="startDateChange"
                                        :picker-options="startDateOption"></el-date-picker>
                        至
                        <el-date-picker type="month" placeholder="结束时间"
                                        ref="endDate"
                                        v-model="ruleForm.endDate" @change="endDateChange"
                                        :picker-options="endDateOption"></el-date-picker>
                    </div>
                </el-form-item>
            </div>
            <el-form-item label="专业描述:" style="padding-right:30px">
                <p class="f-view pre-wrap" v-text="ruleForm.majorDesc"></p>
                <el-input class="f-edit" type="textarea" :autosize="{ minRows: 3, maxRows: 5}"
                          v-model="ruleForm.majorDesc"
                          :maxlength="1000"
                          resize="none"></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>
<script type="text/javascript">
    import pattern from 'modules/pattern'
    import axios from 'axios'
    import _ from 'underscore'
    import { dateFormat } from 'modules/tools'
    import RemoteSelect from 'components/remoteSelect'
    import dateOptionMixin from 'mixins/dateOptionMixin'
    import FormCommonMixin from 'mixins/formCommonMixin'
    import selectMapMixin from 'mixins/selectMapMixin'

    const fieldName = 'resumeEducations'

    export default {
        props: {
            init: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                urls: {
                    add: '/resume/resumeEducation/insert.api',
                    update: '/resume/resumeEducation/update.api',
                    remove: '/resume/resumeEducation/delete.api'
                },
                ruleForm: this.init,
                resetData: Object.assign({}, this.init),
                rules: {
                    school: [
                        {required: true, message: '请输入学校名称', trigger: 'blur'}
                    ],
                    major: [
                        {required: true, message: '请输入专业名称', trigger: 'blur'}
                    ],
                    degree: [
                        {type: 'number', required: true, message: '请选择学历', trigger: 'blur,change'}
                    ]
                },
                isEdit: !(this.init.isEdit === false)
            }
        },
        mixins: [dateOptionMixin, FormCommonMixin, selectMapMixin],
        computed: {
            rangeStartDate () {
                return this.ruleForm.beginDate
            },
            selectMap () {
                return this.$store.state.baseData.selectMap
            },
            postData () {
                return Object.assign({}, _.omit(this.ruleForm, ['beginDate', 'endDate', '_index', 'isEdit', 'degreeName', 'degrees']), {
                    'beginDate': dateFormat(this.ruleForm.beginDate),
                    'endDate': dateFormat(this.ruleForm.endDate)
                })
            },
            durationDateText () {
                return this.ruleForm.beginDate ? dateFormat(this.ruleForm.beginDate, 'yyyy年MM月') + ' - ' + (this.ruleForm.endDate ? dateFormat(this.ruleForm.endDate, 'yyyy年MM月') : '至今') : '-'
            }
        },
        methods: {
            updateData () {
                let type = this.ruleForm.id ? 'update' : 'add'
                axios.post(this.urls[type], this.postData, {'X-showMessage': true}).then((res) => {
                    if (type === 'add') {
                        this.$emit('add', res.result.bean, this.ruleForm._index, fieldName)
                    }
                    Object.keys(this.resetData).forEach((item, index) => {
                        this.resetData[item] = res.result.bean[item]
                    })
                    this.editData()
                })
            },
            removeData () {
                let removeData = _.pick(this.postData, ['id', 'resumeId', 'resumePositionId'])
                this.$confirm('是否删除该记录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.post(this.urls.remove, removeData, {'X-showMessage': true}).then(res => {
                        this.$emit('remove', removeData, fieldName)
                    })
                })
            },
            removeItem (itemData) {
                this.$emit('remove', itemData.id || itemData['_index'])
            },
            transToText (base, field) {
                let target = _.findWhere(this.selectMap[base], {value: this.ruleForm[field] + ''})
                return (target && target.text) || ''
            },
            editData () {
                this.isEdit = !this.isEdit
            },
            cancelEdit () {
                if (this.postData.id) {
                    this.resetForm('ruleForm')
                    this.resetDataFn()
                    this.editData()
                } else {
                    this.$emit('remove', _.pick(this.postData, ['id', 'resumeId', 'resumePositionId']), fieldName)
                }
            },
            resetDataFn () {
                Object.keys(this.ruleForm).forEach((item, index) => {
                    this.ruleForm[item] = this.resetData[item]
                })
            },
            saveData (formName, callback) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        callback(this.postData)
                    } else {
                        return false
                    }
                })
            }
        },
        components: {
            RemoteSelect
        }
    }

</script>


// WEBPACK FOOTER //
// education.vue?4b98512c